// extracted by mini-css-extract-plugin
export default {"container":"fy0T0","containerIn":"R8Zf7","type--plain":"vdBVg","wrap":"gW59l","align--center":"eI0FF","align--left":"jdYwJ","align--right":"erMnG"};